import { values } from 'lodash';
import { JobIcons } from 'constants/icons';
import { MENU_PORTAL_PROPS } from 'components/selects/RepositioningMenuPortal';

export const ADVANCED_METRICS = {
  CHART_PROPS: {
    width: '95%',
    height: 450,
  },
  CHART_MARGIN: { top: 40, right: 0, left: 0, bottom: 40 },
  CHART_TITLE_PROPS: {
    x: '54%',
    y: 10,
    textAnchor: 'middle',
    dominantBaseline: 'central',
    fontSize: 20,
  },
  X_AXIS_PROPS: {
    dataKey: 'week',
    type: 'number',
    allowDecimals: false,
    label: { value: 'Weeks on Course', position: 'insideBottom', offset: -1 },
  },
  Y_AXIS_PROPS: {
    dataKey: 'value',
    allowDecimals: false,
    label: {
      value: 'Program Days Completed',
      position: 'insideLeft',
      angle: -90,
      offset: 10,
      style: { textAnchor: 'middle' },
    },
  },
};

export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD';

export const BACKEND_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const SCHEDULER_DAY_START_HOUR = 6;

export const CACHE_DURATION = 30000;

export const CANCELLATION_REASONS = {
  AIRCRAFT: 'Aircraft U/S',
  AIRCREW: 'Aircrew',
  MAINTENANCE: 'Maintenance',
  SAR: 'Sar',
  WEATHER: 'Weather',
  OTHER: 'Other',
};

export const CHECKBOXES = {
  ALL: 'All',
};

export const COHORTS_STATUS = {
  CURRENT: 'Current',
  ARCHIVED: 'Archived',
};

export const CREW_LIST = ['QFI', 'AVWI', 'QAI', 'PILOT', 'AVWO', 'SENSO', 'AGI'];

export const DAILY_STATUS = {
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT',
  IN_PLANNING: 'IN_PLANNING',
};

export const DAILY_STATUS_LABEL = {
  PUBLISHED: 'Published',
  DRAFT: 'Draft',
  IN_PLANNING: 'In Planning',
};

export const DATASET_BACKUP_STATUS = {
  CREATED: 'CREATED',
  PROCESSING: 'PROCESSING',
  ERROR: 'ERROR',
  TYPE: 'BACKUP',
};

export const DATASET_EXPORT_STATUS = {
  EXPORTED: 'EXPORTED',
  PROCESSING: 'PROCESSING',
  ERROR: 'ERROR',
  TYPE: 'EXPORT',
};

export const DATASET_GROUPS = {
  EMPTY: 'OTHERS',
  LIVE: 'LIVE',
};

export const DEFAULT_DATASET_STATUS = {
  AVAILABLE: 'AVAILABLE',
  ERROR: 'ERROR',
  IMPORTING: 'IMPORTING',
  TYPE: 'IMPORT',
};

export const JOB_TYPE = {
  SCHEDULE: 'SCHEDULE',
  VALIDATE: 'VALIDATE',
  SIMULATE: 'SIMULATE',
  TEST: 'TEST',
  LOGS: 'LOGS',
};

export const JOB_STATUS_TYPE = {
  QUEUED: 'QUEUED',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
};

export const JOB_STATUS = {
  isSucceeded: (status) => status === JOB_STATUS_TYPE.SUCCEEDED,
  isFailed: (status) => status === JOB_STATUS_TYPE.FAILED,
  isCanceled: (status) => status === JOB_STATUS_TYPE.CANCELLED,
};

export const JOB_REVIEW_TYPE = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
};

export const JOB_REVIEW = {
  isAccepted: (review) => review && review.decision === JOB_REVIEW_TYPE.ACCEPTED,
  isRejected: (review) => review && review === JOB_REVIEW_TYPE.REJECTED,
  isPending: (review) => review && review.decision === JOB_REVIEW_TYPE.PENDING,
};

export const ENGINE_JOB_ICONS = {
  [JOB_STATUS_TYPE.QUEUED]: JobIcons.JobInProgress,
  [JOB_STATUS_TYPE.RUNNING]: JobIcons.JobInProgress,
  [JOB_STATUS_TYPE.COMPLETED]: JobIcons.JobInProgress,
  [JOB_STATUS_TYPE.SUCCEEDED]: JobIcons.JobSuccess,
  [JOB_STATUS_TYPE.FAILED]: JobIcons.JobFailedIcon,
  [JOB_STATUS_TYPE.CANCELLED]: JobIcons.JobCancelIcon,
};

export const ENROLMENT_PROGRESS_STATUS = {
  COMPLETED: 'COMPLETED',
  DEFERRED: 'DEFERRED',
  EXEMPTED: 'EXEMPTED',
  FAILED: 'FAILED',
  PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
  PLANNED: 'PLANNED',
  RESET: 'RESET',
  TO_BE_PLANNED: 'TO_BE_PLANNED',
  UNPLANNED: 'NOT PLANNED',
};

export const ENROLMENT_STATUS = {
  CURRENT: 'CURRENT',
  DORMANT: 'DORMANT',
  ARCHIVED: 'ARCHIVED',
  INACTIVE: 'INACTIVE',
};

export const ENROLMENT_STATUS_LABEL = {
  GRADUATED: 'Graduated',
  CURRENT: 'Current',
  DORMANT: 'Dormant',
  ARCHIVED: 'Archived',
  INACTIVE: 'Inactive',
  DID_NOT_COMPLETE: 'Not Completed',
};

export const EVENT_PHASES = {
  BRIEF: 'BRIEF',
  PREP: 'PREP',
  EVENT: 'EVENT',
  DEBRIEF: 'DEBRIEF',
  POST: 'POST',
};

export const EVENT_PHASES_ORDER = values(EVENT_PHASES);

export const EVENT_STATUS = {
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  ON_HOLD: 'ON_HOLD',
  PLANNED: 'PLANNED',
};

export const FLYPRO_GROUP_EVENT_TYPE_OPTIONS = [
  { name: 'flying_event', value: 'flying_event', label: 'Flying Event', isChecked: false },
  { name: 'simulator_event', value: 'simulator_event', label: 'Simulation Event', isChecked: false },
  { name: 'meeting_event', value: 'meeting_event', label: 'Meeting Event', isChecked: false },
  { name: 'other_event', value: 'other_event', label: 'Other Event', isChecked: false },
];

export const HISTORY_STATUS = {
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
  DELETED: 'DELETED',
  RESTORED: 'RESTORED',
};

export const HISTORY_STATUS_OPTIONS = [
  { value: 'CREATED', label: 'Created', color: 'rgb(87, 217, 163)' },
  { value: 'UPDATED', label: 'Updated', color: 'rgb(255, 196, 0)' },
  { value: 'DELETED', label: 'Deleted', color: 'rgb(222, 53, 11)' },
  { value: 'RESTORED', label: 'Restored', color: 'rgb(255, 196, 0)' },
];

export const HUMAN_ENROLMENT_STATUS_LIST = {
  CURRENT: 'CURRENT',
  GRADUATED: 'GRADUATED',
  NOT_COMPLETED: 'DID_NOT_COMPLETE',
  DORMANT: 'DORMANT',
  ARCHIVED: 'ARCHIVED',
};

export const HUMAN_STATUS = {
  ACTIVE: 'ACTIVE',
  DORMANT: 'DORMANT',
  ARCHIVED: 'ARCHIVED',
};

export const HUMAN_TYPE = {
  QUALIFICATION: 'QUALIFICATION_TYPE',
  STUDENT: 'STUDENT',
  SUPPORT: 'SUPPORT',
};

export const INVALIDATION_REASON_LABEL = {
  LESSON_DELETED: 'Source activity soft deleted',
  EVENT_DELETED: 'Attached event soft deleted',
  EVENT_CANCELLED: 'Attached event cancelled',
};

export const ACTIVITY_REQUEST_STATUS = {
  REQUESTED: 'REQUESTED',
  SCHEDULED: 'SCHEDULED',
  COMPLETED: 'COMPLETED',
  RETRACTED: 'RETRACTED',
  INVALID: 'INVALID',
};

export const EVENT_ACTIVITY_REQUESTS_PARTITIONS = {
  overdue: 'Overdue',
  requested: 'Requested',
  attached_other_events: 'Attached (other events)',
  attached_current_event: 'Attached (current event)',
};

export const EVENT_ACTIVITY_REQUESTS_PARTITIONS_PRIORITY = {
  one: { label: 'Priority 1', color: '#e74c3c' },
  twoToFive: { label: 'Priority 2-5', color: '#f39c12' },
  sixToTen: { label: 'Priority 6-10', color: '#f1c40f' },
  elevenToTwenty: { label: 'Priority 11-20', color: '#2ecc71' },
  twentyOneAndAbove: { label: 'Priority 21+', color: '#3498db' },
};

export const LESSONS_API_CALLS = {
  LESSON_VERSIONS_CHAIN_WITH_PHASES_SHARED_PREREQ: (lessonId) => ({
    lesson_id: lessonId,
    include_phases: true,
    include_shared_lessons: true,
    include_prerequisites: true,
    count_events: true,
  }),
  LESSON_VERSION_WITH_PHASES_SHARED_PREREQ: (versionId) => ({
    version_id: versionId,
    include_phases: true,
    include_shared_lessons: true,
    include_prerequisites: true,
  }),
  LESSONS_VERSIONS_WITH_PREREQ_CURRENT_ACTIVE_DELETED: {
    include_phases: false,
    include_shared_lessons: false,
    include_prerequisites: true,
    included_version_statuses: ['CURRENT'],
    included_template_statuses: ['ACTIVE', 'DELETED'],
  },
  LESSONS_VERSIONS_CURRENT_ACTIVE_DELETED: {
    include_phases: false,
    include_shared_lessons: false,
    include_prerequisites: false,
    included_version_statuses: ['CURRENT'],
    included_template_statuses: ['ACTIVE', 'DELETED'],
  },
  SYLLABUS_LESSON_VERSIONS_WITH_PREREQ: (syllabusId) => ({
    syllabus_id: syllabusId,
    include_prerequisites: true,
  }), //Syllabus page
  SYLLABUS_LESSON_VERSIONS_CURRENT_ACTIVE: (syllabusId) => ({
    syllabus_id: syllabusId,
    include_shared_lessons: true,
    included_version_statuses: ['CURRENT'],
    included_template_statuses: ['ACTIVE'],
  }),
};

export const LESSON_LAYOUT_TYPES = {
  FLY: 'FLY',
  FIGHT: 'FIGHT',
};

export const LESSON_STATUS = {
  CURRENT: 'CURRENT',
  DEPRECATED: 'DEPRECATED',
};

export const LESSON_STATUSES = [
  { value: LESSON_STATUS.CURRENT, label: 'Current' },
  { value: LESSON_STATUS.DEPRECATED, label: 'Deprecated' },
];

export const LESSON_TEMPLATE_STATUS = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
};

export const LESSON_TEMPLATE_STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'Active', color: 'rgb(211 239 255)' },
  { value: 'DELETED', label: 'Deleted', color: 'rgb(236 82 33)' },
];

export const LESSON_VERSION_STATUS = {
  CURRENT: 'CURRENT',
  DEPRECATED: 'DEPRECATED',
};

export const LESSON_VERSION_STATUS_OPTIONS = [
  { value: 'CURRENT', label: 'Current', color: 'rgb(87, 217, 163)' },
  { value: 'DEPRECATED', label: 'Deprecated', color: 'rgb(220,218,218)' },
];

export const MANAGED_ITEMS_TABS = [
  { label: 'Qualifications', component: 'QUALIFICATIONS', isHidden: false },
  { label: 'Metric Types', component: 'METRIC_TYPES', isHidden: false },
  { label: 'Unavailability Types', component: 'UNAVAILABILITY_TYPES', isHidden: false },
  { label: 'Cancellation Reasons', component: 'CANCELLATION_REASONS', isHidden: false },
  { label: 'Top Bar Templates', component: 'TOP_BAR_TEMPLATES', isHidden: false },
  { label: 'Duty Templates', component: 'DUTY_TEMPLATES', isHidden: false },
  { label: 'Sticky Note Templates', component: 'STICKY_NOTE_TEMPLATES', isHidden: false },
  { label: 'Flypro Groups', component: 'FLYPRO_GROUPS', isHidden: false },
  { label: 'Personnel Tags', component: 'HUMAN_TAGS', isHidden: false },
];

export const months = [
  { key: 'jan', display: 'January' },
  { key: 'feb', display: 'February' },
  { key: 'mar', display: 'March' },
  { key: 'apr', display: 'April' },
  { key: 'may', display: 'May' },
  { key: 'jun', display: 'June' },
  { key: 'jul', display: 'July' },
  { key: 'aug', display: 'August' },
  { key: 'sep', display: 'September' },
  { key: 'oct', display: 'October' },
  { key: 'nov', display: 'November' },
  { key: 'dec', display: 'December' },
];

export const NILL_OPTION = {
  label: 'nil',
  value: 'nil',
};

export const NONE = 'none';

export const OPTIONS = {
  PRIORITY_OPTIONS: [
    { label: 'High', value: 'HIGH' },
    { label: 'Standard', value: 'STANDARD' },
  ],
};

export const PERSONNEL_LABEL = {
  STUDENTS: 'Students',
  SUPPORT: 'Support',
};

export const PHASES_ENUM = ['PREP', 'BRIEF', 'EVENT', 'DEBRIEF', 'POST'];

export const PRIORITY = {
  HIGH: 'HIGH',
  STANDARD: 'STANDARD',
};

export const PROPERTY_OPTIONS = [
  { label: 'AIRCRAFT', value: 'AIRCRAFT' },
  { label: 'OTHER', value: 'OTHER' },
  { label: 'SIMULATOR', value: 'SIMULATOR' },
  { label: 'MEETING ROOM', value: 'MEETINGROOM' },
];

export const QUALIFICATION_GROUP_TYPES = {
  HUMAN: 'HUMAN',
  NON_HUMAN: 'NON-HUMAN',
};

export const QUALIFICATION_TYPES = {
  BASE_CONFIG: 'BASE_CONFIG',
  DESIRED_BASE: 'DESIRED_BASE',
  CONFIG: 'CONFIG',
  DESIRED_CONFIG: 'DESIRED_CONFIG',
  HUMAN: 'HUMAN',
};

export const RESOURCE_FETCH_ALL = {
  resources: true,
  resourceTypes: true,
  configs: true,
  configTypes: true,
  configGroups: true,
};

export const RESOURCE_KIND = {
  HUMAN: 'HUMAN',
  RESOURCE: 'RESOURCE',
};

export const RESOURCE_PROPERTIES = {
  AIRCRAFT: 'AIRCRAFT',
  INSTRUCTOR: 'INSTRUCTOR',
  SIMULATOR: 'SIMULATOR',
  NONE: 'NONE',
  OTHERS: 'OTHER',
};

export const RESOURCE_STATUS = {
  ALL: 'ALL',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DORMANT: 'DORMANT',
  ARCHIVED: 'ARCHIVED',
};

export const RESOURCE_TYPES = {
  AIRCRAFT: 'Aircraft',
  OFT: 'OFT',
  TOFT: 'TOFT',
  WTT: 'WTT',
};

export const SAR_SCOPES = {
  GLOBAL: 'GLOBAL',
  DAILY: 'DAILY',
};

export const SAR_TYPE_OPTIONS = [
  { label: 'Land Based SAR', value: 'Land' },
  { label: 'Helo Based SAR', value: 'Helo' },
  { label: 'Other', value: 'Other' },
];

export const SELECT_PORTAL_PROPS = {
  ...MENU_PORTAL_PROPS,
  styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
};

export const SERVICE_TYPE = {
  ARMY: 'ARMY',
  NAVY: 'NAVY',
};

export const STATUS_POLLING_INTERVAL = 3 * 1000;

export const STUDENT_SCHOOL_STATUS = {
  CURRENT: 'current',
  GRADUATED: 'graduated',
  NOT_COMPLETED: 'notCompleted',
  DORMANT: 'dormant',
  ARCHIVED: 'archived',
  INACTIVE: 'inactive',
};

export const STUDENT_STATUS = {
  COMPLETED: 'COMPLETED',
  DEFERRED: 'DEFERRED',
  EXEMPTED: 'EXEMPTED',
  FAILED: 'FAILED',
  PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
  PLANNED: 'PLANNED',
  TBP: 'TBP',
  UNPLANNED: 'NOT PLANNED',
};

export const STUDENT_STATUS_LIST = {
  CURRENT: 'CURRENT',
  GRADUATED: 'GRADUATED',
  NOT_COMPLETED: 'DID_NOT_COMPLETE',
  DORMANT: 'DORMANT',
  ARCHIVED: 'ARCHIVED',
};

export const STUDENT_STATUS_OPTIONS = [
  { label: 'Current', value: 'CURRENT' },
  { label: 'Graduated', value: 'GRADUATED' },
  { label: 'Not Completed', value: 'DID_NOT_COMPLETE' },
  { label: 'Dormant', value: 'DORMANT' },
  { label: 'Archived', value: 'ARCHIVED' },
];

export const STUDENT_TRACKER_UI = {
  ROWS_PER_PAGE: 20,
};

export const SYLLABUS_TYPE_OPTIONS = [
  { label: 'Training', value: 'TRAINING' },
  { label: 'Operations', value: 'OPERATIONS' },
  { label: 'Remedial', value: 'REMEDIAL' },
  { label: 'Custom', value: 'CUSTOM' },
];

export const SYLLABUS_TYPES = {
  TRAINING: 'TRAINING',
  OPERATIONS: 'OPERATIONS',
  REMEDIAL: 'REMEDIAL',
  CUSTOM: 'CUSTOM',
};

export const timeSlots = [
  '06:00',
  '06:15',
  '06:30',
  '06:45',
  '07:00',
  '07:15',
  '07:30',
  '07:45',
  '08:00',
  '08:15',
  '08:30',
  '08:45',
  '09:00',
  '09:15',
  '09:30',
  '09:45',
  '10:00',
  '10:15',
  '10:30',
  '10:45',
  '11:00',
  '11:15',
  '11:30',
  '11:45',
  '12:00',
  '12:15',
  '12:30',
  '12:45',
  '13:00',
  '13:15',
  '13:30',
  '13:45',
  '14:00',
  '14:15',
  '14:30',
  '14:45',
  '15:00',
  '15:15',
  '15:30',
  '15:45',
  '16:00',
  '16:15',
  '16:30',
  '16:45',
  '17:00',
  '17:15',
  '17:30',
  '17:45',
  '18:00',
  '18:15',
  '18:30',
  '18:45',
  '19:00',
  '19:15',
  '19:30',
  '19:45',
  '20:00',
  '20:15',
  '20:30',
  '20:45',
  '21:00',
  '21:15',
  '21:30',
  '21:45',
  '22:00',
  '22:15',
  '22:30',
  '22:45',
  '23:00',
  '23:15',
  '23:30',
  '23:45',
  '00:00',
  '00:15',
  '00:30',
  '00:45',
  '01:00',
  '01:15',
  '01:30',
  '01:45',
  '02:00',
  '02:15',
  '02:30',
  '02:45',
  '03:00',
  '03:15',
  '03:30',
  '03:45',
  '04:00',
  '04:15',
  '04:30',
  '04:45',
  '05:00',
  '05:15',
  '05:30',
  '05:45',
];

export const DOWNLOAD_DATE_FORMAT = 'DD.MM.YYYY';

export const REACT_DATE_PICKER_FORMAT = 'dd/MM/yyyy';

export const UI_DEFAULT_END_TIME = '23:59';

export const UI_DEFAULT_START_TIME = '00:00';

export const UI_DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';

export const UI_DISPLAY_DATE_PICKER_PLACEHOLDER = 'e.g. 01/01/2018';

export const UI_DISPLAY_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';

export const UI_DISPLAY_TIME_FORMAT = 'HH:mm';

export const UI_DROPDOWN_TIME_FORMAT = 'HH:mm:ss';

export const UI_PRINT_DATE_FORMAT = 'ddd DD MMM YYYY';

export const UI_PRINT_DATE_FORMAT_NO_DAY = 'DD MMM YYYY';

export const UI_PRINT_DATE_TIME_FORMAT = 'DD MMM YYYY, HH:mm';

export const UNAVAILABILITY_INHERITANCE = {
  BASE: 'Base',
  FLIGHT: 'Flight',
  INDIVIDUAL: 'Individual',
  GROUP: 'Group',
  HUMAN: 'Human',
  RESOURCE_INSTANCE: 'ResourceInstance',
  RESOURCE_TYPE: 'ResourceType',
  SCHOOL: 'School',
  SQUADRON: 'Squadron',
  STREAM: 'Stream',
  STUDENT_INSTANCE: 'StudentInstance',
  STUDENT_TYPE: 'StudentType',
  TRAINING_FACILITY: 'TrainingFacility',
};

export const UNAVAILABILITY_TYPES = {
  HUMAN: 'Human',
  FLIGHT: 'Flight',
  GROUP: 'Group',
  RESOURCE_TYPE: 'ResourceType',
  RESOURCE_INSTANCE: 'ResourceInstance',
  STUDENT_INSTANCE: 'StudentInstance',
  SCHOOL: 'School',
  TRAINING_FACILITY: 'TrainingFacility',
};

export const USER_ROLE = {
  ADMIN: 'ADMIN',
  OPSO: 'OPSO',
  PLANNER: 'PLANNER',
  FLOPSO: 'FLOPSO',
  INSTRUCTOR: 'INSTRUCTOR',
  COURSE_MANAGER: 'COURSE_MANAGER',
  STAFF: 'STAFF',
  STUDENT: 'STUDENT',
  VIEWER: 'VIEWER',
  VIEWER_PLUS: 'VIEWER_PLUS',
  SUPPORT: 'SUPPORT',
  DOOD: 'DOOD',
  AWOP: 'AWOP',
  AWOP_LIVE: 'AWOP_LIVE',
};

export const USER_ROLES_GROUPS = {
  MOST_PRIVILEGED: [USER_ROLE.ADMIN, USER_ROLE.OPSO],
  HIGH_PRIVILEGED: [USER_ROLE.ADMIN, USER_ROLE.OPSO, USER_ROLE.AWOP],
  MEDIUM_PRIVILEGED: [USER_ROLE.ADMIN, USER_ROLE.OPSO, USER_ROLE.AWOP, USER_ROLE.PLANNER],
  ADMIN_OPSO_PLANNER_PRIVILEGED: [USER_ROLE.ADMIN, USER_ROLE.OPSO, USER_ROLE.PLANNER],
  ADMIN_AWOP_PRIVILEGED: [USER_ROLE.ADMIN, USER_ROLE.AWOP, USER_ROLE.AWOP_LIVE],
};

export const WATERFALL_BAR_COLORS = [
  '#4CAF50',
  '#537DAB',
  '#DB2536',
  '#FFD700',
  '#A35638',
  '#E08F62',
  '#D7C79E',
  '#9DAB86',
  '#F8B195',
  '#F67280',
  '#C06C84',
  '#6C567B',
  '#F08080',
  '#B3C09B',
  '#4DA1A9',
  '#2E5077',
];

export const weekdays = [
  { key: 'sunday', display: 'Sunday' },
  { key: 'monday', display: 'Monday' },
  { key: 'tuesday', display: 'Tuesday' },
  { key: 'wednesday', display: 'Wednesday' },
  { key: 'thursday', display: 'Thursday' },
  { key: 'friday', display: 'Friday' },
  { key: 'saturday', display: 'Saturday' },
];

export const WEEKDAY_DISPLAY_DATE_FORMAT = 'ddd DD MMM, YYYY';

export const ENGINE_PARAM_TYPE = {
  PLANNING: 'PLANNING',
  SIMULATION: 'SIMULATION',
};
